import { Reason } from './types';

export const REASONS_SHOW_LIMIT = 3;

export const REASON_ORDER = [
  'role_match',
  'seniority',
  'on_time_arrival',
  'conflicting_shift',
  'overtime',
];

export const orderReasons = (reasonsToSort: Reason[] | null | undefined) => {
  if (!reasonsToSort) return [];
  const reasons = [...reasonsToSort]
    .sort((a, b) => {
      const indexA = REASON_ORDER.indexOf(a.reason_key);
      const indexB = REASON_ORDER.indexOf(b.reason_key);
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    })
    .slice(0, REASONS_SHOW_LIMIT);

  return reasons;
};
